export const footerQuery = `*[_type == 'footer'] {
  siteTagline,
  menu,
  topMenu,
  copyright,
  privacy
}[0]`